import $ from 'jquery';

const Share = (el) => {
    const $el = $(el);
    const url = $el.data('url');
    $el.click((e) => {
        e.preventDefault();

        const style = 'toolbar,scrollbars,resizable,top=100,left=100,width=800,height=500';
        window.open(url, '_blank', style);
    });
};

export default Share;
